<template>
    <section class="interview-title light blue">
        <div class="css-grid panel-left">
            <div class="bg" style="background-image: url(/static/img/pages/interview-wim-kees-front.jpg)"></div>

            <div class="content-wrapper">
                <div class="content light blue">
                    <h3>Interview Kees&nbsp;Vrieswijk, Wim&nbsp;van&nbsp;der&nbsp;Maas, Mijntje&nbsp;Stoof en Nick&nbsp;van&nbsp;Nunen</h3>
                    <h2>Innovatieve technieken ontwikkelen docenten, studenten &eacute;n het beroepsonderwijs</h2>
                    <button @click="openInterview">Lees het interview</button>
                </div>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
    .bg{
        background-position: 10% center !important;
    }

    .content-wrapper{
        grid-row: 4/span 4 !important;
    }
</style>

<script>
    import InterviewWimKees from '@/app/pages/sub/InterviewWimKees';

    export default {
        name: 'MedewerkerInterview',
        meta: {
            title: 'MedewerkerInterview',
            color: '#36B1CA'
        },

        components: {
        },

        methods: {
            openInterview()
            {
                this.$emit( 'openOverlay', InterviewWimKees );
            }
        }
    };
</script>
